export class FilterOption {
	public Id: string;
	public Name: string;

	constructor(id: string | number,
	            name: string) {
		this.Id = String(id);
		this.Name = name;
	}
}